import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { map, Observable } from 'rxjs';

import { skipMessagingKey } from '../../../core/services/http.context';
import { MessagingEnvironmentService } from '../../../core/services/messaging-environment.service';
import { TextProcessorModalComponent } from '../components/text-processor/text-processor.component';
import { IChannel } from '../interfaces/IChannel';
import { DealerSettingName } from '../interfaces/IDealerSettings';
import { Suggestion } from '../interfaces/IMessage';
import { WorkspaceFeatures } from '../interfaces/IWorkspace';
import { PermissionsService } from './permissions.service';
import { TranslaterService } from './translater.service';

export enum Side {
  internal = 'HUMAN_AGENT',
  external = 'END_USER',
}
@Injectable()
export class TextProcessorService {
  selectedChannel: IChannel;

  constructor(
    private httpClient: HttpClient,
    private permissionsService: PermissionsService,
    private env: MessagingEnvironmentService,
    private translaterService: TranslaterService,
    public dialog: MatDialog
  ) {}

  openProcessor(text: string, isSmartReplyOrAutoResponse: boolean) {
    const dialogRef = this.dialog.open(TextProcessorModalComponent, {
      width: '600px',
      panelClass: 'custom-close-button-modal',
      data: {
        original: text,
        isSmartResponse: isSmartReplyOrAutoResponse,
      },
    });
    return dialogRef.afterClosed();
  }

  professionalizeMessage(message: string): Observable<string> {
    return this.httpClient
      .post<Suggestion[]>(
        `${this.env.env.textProcessorApiUrl}/smart-reply/professionalize`,
        {
          message: message,
          lang: this.translaterService?.dealerLanguge || 'en',
        },
        {
          context: skipMessagingKey(),
        }
      )
      .pipe(map((responses) => responses[0]?.text));
  }

  verifyCanProffesionalize(): boolean {
    return (
      this.permissionsService.checkWorkspaceFeatures([WorkspaceFeatures.canProfessionalizeMessages]) &&
      this.permissionsService.checkDealerSetting(DealerSettingName.messageProfessionalizationEnabled)
    );
  }
}
